
import { Avatar_02, Avatar_16 } from "Routes/ImagePath";
import { imageKitResize, parsePx } from "utils/imageKit";

const Image = (props) => {
  // Add lazy loading by default unless explicitly disabled. w/h are pulled out
  // so they never leak onto the <img> as invalid DOM attributes.
  const { loading = "lazy", w, h, ...restProps } = props;
  const { src, type, style } = props;

  let finalSrc = src;
  if (type === "user" && src) {
    // Render avatars at 2x for retina crispness. Size is taken per call site:
    // explicit w/h prop first, else the element's own pixel style, else 160.
    const dpr = 2;
    const styleW = parsePx(style?.width);
    const styleH = parsePx(style?.height);
    const baseW = w || styleW || styleH || 160;
    const baseH = h || styleH || styleW || baseW;
    finalSrc = imageKitResize(src, baseW * dpr, baseH * dpr);
  }

  return (
    <img
      {...restProps}
      loading={loading}
      src={
        finalSrc ||
        require(`assets/img/${type == "user" ? "user.jpg" : "placeholder.webp"}`)
      }
    />
  );
};
export default Image;
